module.exports = __webpack_public_path__ + "static/media/anchor_rank_1.24df2221.png";